export default "__VITE_ASSET__B8y5PglF__"